<template>
  <div class="postDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"  @scroll=handleScroll>
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games" v-for="(item,i) in setDetail.img">
        <a href=""><img :src="baseUrl+item"></a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class="nav" :style="positionFlag ? 'position:fixed;top:0;' : ''">
      <a @click="toggle(0)" :class="{curt:0==active}">景区介绍</a>
      <a @click="toggle(1)" :class="{curt:1==active}">一卡通</a>
      <a @click="toggle(2)" :class="{curt:2==active}">视频观看</a>
      <a @click="toggle(3)" :class="{curt:3==active}">作文研学</a>
    </div>

    <div class="info" v-if="active == 0">
      <h2>景区地址：{{setDetail.address}}</h2>
      <h2>营业时间：{{setDetail.business}}</h2>
      <h2>咨询电话：<a :href="'tel:'+setDetail.tel">{{setDetail.tel}}</a></h2>
      <div class="js" v-html="setDetail.content">
      </div>
    </div>

    <div class="card" v-if="active == 1">
      <ul>
        <li v-for="(item,i) in arr">
          <h3>{{item.title}}</h3>
          <div class="price"><font>售<i style="opacity:0">场</i>价：</font>￥{{item.rate}}</div>
          <div class="rate"><font>市场价：</font><span style="text-decoration: line-through">￥{{item.price}}</span></div>
          <a>购买</a>
        </li>
        
      </ul>
    </div>

    <div class="video" v-if="active == 2">
       <videoPlayer v-if="setDetail.video != ''" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></videoPlayer>
    </div>
    <div class="study" v-if="active == 3">
      <ul>
        <li v-for="(item,i) in study" @click="toPush(item.id,'join')">
          <img class="titImg" :src="setDetail.fmt == '' ? baseUrl+item.img : baseUrl+setDetail.fmt" />
          <h2>{{item.title}}</h2>
          <div class="source">
            <img class="avatar" :src="item.avatar" />
            <span>{{item.username}}</span>
            <font>
              <img src="~assets/images/like.png" />
              {{item.read}}
            </font>
          </div>
        </li>
      </ul>

      <a class="creation" v-if="setDetail.isstar == 1" @click="goHref">我要创作</a>
    </div>

  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { videoPlayer } from 'vue-video-player'
  import '../../assets/video.js/dist/video-js.css'
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },

        playerOptions: {
           playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
           autoplay: false, // 如果为true,浏览器准备好时开始回放。
           muted: false, // 默认情况下将会消除任何音频。
           loop: false, // 是否视频一结束就重新开始。
           preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
           language: 'zh-CN',
           aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
           fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
           sources: [{
            type: "video/mp4", // 类型
            src: '' // url地址
           }],
           poster: '', // 封面地址
           notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
           controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: false, // 显示持续时间
              remainingTimeDisplay: true, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
           }
        },
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        active:0,
        arr:[],
        positionFlag:false,
        study:[]
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      window.addEventListener('scroll', () => {
        let scrollTop = document.documentElement.scrollTop ||
                         document.body.scrollTop ||
                         document.querySelector('.postDetailApp').scrollTop;
        if (scrollTop > 235) {
          this.positionFlag = true
        } else {
          this.positionFlag = false
        }
      }, true);
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      save:function(){
        alert('请接入客户微信支付，内部微信支付已关停')
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      goHref:function(){
        var id = this.$route.query.id;
        window.location.href = "http://user.4008005216.com/main/add?id="+id;
        //window.location.href = "http://192.168.1.19:8080/main/add?id="+id;
      },

      toggle(index){
        this.active=index;
        if(index == 3){
          this.getStudy();
        }
      },
      handleScroll () {
        var scrollTop = this.scrollTop
        if (scrollTop > 135) {
          this.positionFlag = true
        } else {
          this.positionFlag = false
        }
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/detail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data.rs;
          that.arr = res.data.arr;
          that.playerOptions.sources[0].src = that.$host+res.data.rs.video;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getStudy:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/study/index',
          params:{
            s_id:id,
            page:1
          }
        }).then(function(response){
          var res = response.data;
          that.study = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    },
    components: {
      videoPlayer
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .postDetailApp{
    background:#f5f5f5;
  }
  .postDetailApp .swiper-slide{
    width:100%
  }
  .postDetailApp .swiper-slide img{
    display:block;
    width:100%;
  }
  .postDetailApp .nav{
    display: flex;
    margin: 0 auto;
    flex-wrap: nowrap;
    justify-content: space-between;
    width:100%;
    padding:15px 0;
    background:#fff;
  }
  .postDetailApp .nav a{
    display:block;
    width:33.3%;
    text-align:center;
    font-size:15px;
    position:relative;
  }
  .postDetailApp .nav a.curt{
    color:#007aff
  }
  .postDetailApp .nav a:after{
    content:'';
    width:1px;
    height:16px;
    background:#ccc;
    position:absolute;
    right:0;
    top:4px
  }
  .postDetailApp .nav a:last-child:after{
    background:#fff
  }

  .postDetailApp .info{
    background:#fff;
    width:100%;
    display:block;
    margin-top:10px
  }
  .postDetailApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto
  }
  .postDetailApp .info .js{
    width:92%;
    display:block;
    margin:0 auto;
    padding:15px 0;
    line-height:24px;
    letter-spacing:1px;
  }
  .postDetailApp .info .js img{
    display:block;
    width:100%
  }

  .postDetailApp .card{
    width:100%;
    display:block;
    margin-top:10px;
    min-height:400px
  }
  .postDetailApp .card ul{
    width:94%;
    display:block;
    margin:0 auto;
  }
  .postDetailApp .card ul li{
    background:#fff;
    width:100%;
    margin-bottom:8px;
    border-radius:8px;
    position:relative;
  }
  .postDetailApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px
  }

  .postDetailApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#007aff
  }
  .postDetailApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#333
  }
  .postDetailApp .card ul li .price font{
    color:#333;
    font-size:15px
  }
  .postDetailApp .card ul li a{
    position:absolute;
    right:20px;
    top:60%;
    transform: translateY(-50%);
    background:green;
    padding:6px 15px;
    color:#fff;
    border-radius:5px;
  }

  .postDetailApp .video{
    width:92%;
    margin:0 auto;
    min-height:400px;
    margin-top:15px
  }

  .video-js .vjs-big-play-button {
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    outline: none!importrant;
  }
  
  .study ul{
    width: 94%;
    -moz-column-count:2;
    -webkit-column-count:2;
    column-count:2;
    margin-left:2%;
    padding-top:2%
  }
  .study ul li{
    width: 105%;
    -moz-page-break-inside:avoid;
    -webkit-column-break-inside:avoid;
    break-inside:avoid;
    background:#fff;
    border-radius:8px;
    margin-bottom:4%;
    float:left
  }
  .study ul li .titImg{
    display:block;
    width:100%;
    border-top-left-radius:8px;
    border-top-right-radius:8px
  }
  .study ul li h2{
    display:block;
    font-size:15px;
    letter-spacing:1px;
    padding:5px 10px 10px 10px;
    font-weight:normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    color:#000;
  }
  .study ul li .source{
    padding-bottom:10px;
    padding-right:10px
  }
  .study ul li .source:after{
    content:"";
    display: block;
    clear:both;
  }
  .study ul li .source img{
    width:25px;
    border-radius:50%;
    float:left;
    margin-left:10px;
  }
  .study ul li .source span{
    float:left;
    color:#333;
    font-size:14px;
    height:25px;
    line-height:25px;
    margin-left:5px;
  }
  .study ul li .source font{
    float:right;
    color:#333;
    font-size:14px;
    height:25px;
    line-height:25px;
  }
  .study ul li .source font img{
    width:16px;
    position:relative;
    top:4.5px;
    margin-right:3px
  }

  .study .creation{
    position:fixed;
    right:15px;
    bottom:30px;
    background:rgba(0, 122, 255,.6);
    color:#fff;
    font-size:15px;
    width:40px;
    text-align:center;
    border-radius:50%;
    padding:10px
  }
</style>